import * as anchor from "@project-serum/anchor";
import { PublicKey } from "@solana/web3.js";
import { ASSOCIATED_TOKEN_PROGRAM_ID, Token, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import { Metalairs } from "../../idl";
import { AnchorWallet } from "@solana/wallet-adapter-react";
import getMetadata from "../../utils/getMetadata";
import { EMBER_MINT, FEE_COLLECTOR } from "../../vars";

export default async (provider: anchor.AnchorProvider, program: anchor.Program<Metalairs>, mints: PublicKey[]) => {
    const { wallet } = provider
    const [dragoMint] = mints
    const [buildAccount, buildAccountBump] = await anchor.web3.PublicKey.findProgramAddress([Buffer.from("build_account"), wallet.publicKey.toBuffer()], program.programId)
    const [dragoAccount, dragoAccountBump] = await anchor.web3.PublicKey.findProgramAddress([dragoMint.toBuffer()], program.programId)

    const initializerDragoAta = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID, dragoMint, wallet.publicKey)
    const buildDragoAta = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID, dragoMint, buildAccount, true)

    const initializerEmberAta = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID, EMBER_MINT, wallet.publicKey)
    const feeCollectorEmberAta = await Token.getAssociatedTokenAddress(ASSOCIATED_TOKEN_PROGRAM_ID, TOKEN_PROGRAM_ID, EMBER_MINT, FEE_COLLECTOR)

    const dragoMetadata = await getMetadata(dragoMint)

    return program.methods.addBuilder().accounts({
        initializer: wallet.publicKey,
        buildAccount,
        dragoMint,
        dragoAccount,
        dragoMetadata,
        initializerDragoAta,
        buildDragoAta,
        emberMint: EMBER_MINT,
        initializerEmberAta,
        feeCollector: FEE_COLLECTOR,
        feeCollectorEmberAta,
        clock: anchor.web3.SYSVAR_CLOCK_PUBKEY
    }).transaction()
}